import React from 'react';
import { XCircle } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function Problema() {
  const problemas = ['Jugás hace meses o años y sentís que no mejorás.', 'Perdés puntos por errores básicos.', 'No sabés dónde posicionarte en la cancha.', 'Te cuesta jugar en pareja.', 'Dependés solamente de la fuerza.', 'Tus rivales parecen leer cada movimiento.'];
  return <section className="py-14 bg-padel-dark relative border-t border-white/5" data-id="element-193">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-194">
        <FadeIn data-id="element-195">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-center mb-10 uppercase" data-id="element-196">
            ¿Te pasa alguna de{' '}
            <span className="text-red-500" data-id="element-197">estas situaciones?</span>
          </h2>
        </FadeIn>

        <div className="grid gap-3 mb-10" data-id="element-198">
          {problemas.map((prob, idx) => <FadeIn key={idx} delay={idx * 0.1} direction="up" data-id="element-199">
              <div className="bg-white/5 border border-white/10 p-4 rounded-xl flex items-center gap-3 hover:bg-white/10 transition-colors" data-id="element-200">
                <XCircle className="text-red-500 w-6 h-6 flex-shrink-0" data-id="element-201" />
                <p className="text-base md:text-lg font-medium" data-id="element-202">{prob}</p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.6} data-id="element-203">
          <div className="bg-padel-blue border-l-4 border-neon p-8 rounded-r-xl shadow-2xl relative overflow-hidden" data-id="element-204">
            <div className="absolute top-0 right-0 w-32 h-32 bg-neon/10 blur-3xl rounded-full" data-id="element-205"></div>
            <p className="text-xl md:text-2xl font-bold leading-relaxed relative z-10 italic" data-id="element-206">
              "La mayoría de los jugadores amateur no pierde por falta de
              talento.{' '}
              <span className="text-neon" data-id="element-207">
                Pierde porque nadie les enseñó cómo jugar correctamente.
              </span>
              "
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}